import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import CrmSearchInput from '../../shared/components/CrmSearchInput';
import CrmSearchResults from '../../shared/components/CrmSearchResults';
import useCrmSearch from '../../shared/components/useCrmSearch';
import crmLabels from '../../shared/utils/crmLabels';
import useLocalSearchShortcut from '../../shared/hooks/useLocalSearchShortcut';

function GlobalSearch({ teamId, labels = crmLabels(undefined) }) {
  const s = useCrmSearch(teamId);
  const containerRef = useRef(null);
  const inputRef = useRef(null);
  const shortcut = useLocalSearchShortcut(inputRef);

  useEffect(() => {
    const onClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) s.setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className="crm-gsearch" ref={containerRef}>
      <CrmSearchInput
        value={s.q}
        onChange={(e) => s.setQ(e.target.value)}
        onKeyDown={s.onKeyDown}
        onFocus={() => { if (s.term) s.setOpen(true); }}
        useDebounce={false}
        inputRef={inputRef}
        placeholder="Search contacts, deals, tasks"
        ariaLabel="Search CRM"
        shortcutLabel={shortcut}
      />

      {s.open && s.term && (
        <CrmSearchResults
          data={s.data}
          loading={s.loading}
          term={s.term}
          teamId={teamId}
          active={s.active}
          setActive={s.setActive}
          go={s.go}
          seeAllHref={s.seeAllHref}
          labels={labels}
        />
      )}
    </div>
  );
}

GlobalSearch.propTypes = {
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  labels: PropTypes.object,
};

export default GlobalSearch;
